import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TempExtrusionService{
  // private apiUrl = "http://localhost:3003/api/tempExtrusion";
   private apiUrl = "https://lexipackghana.com:3003/api/tempExtrusion";

  constructor(private http: HttpClient) {}
  addTempExtrusion(data:any){
    return this.http.post(this.apiUrl+'/addTempExtrusion',data);
  }
  getTempExtrusion(){
    return this.http.get(this.apiUrl+'/getAllTempExtrusion');
  }
  getTempExtrusionById(id: string) {
    return this.http.get(this.apiUrl + '/' + id);
  }
  updateTempExtrusion(id: string, data: any) {
    return this.http.put(this.apiUrl + '/' + id, data);
  }
}
